var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_vm._m(0),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view',{key:_vm.$route.fullPath})],1)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row",staticStyle:{"min-height":"50px"}},[_c('div',{staticClass:"col-12"},[_c('div',{attrs:{"id":"commandBarSpotlight"}})])])
}]

export { render, staticRenderFns }